import React from 'react';

function Process({ language = 'en' }) {
  const processes = [
    {
      number: '1',
      title: { en: 'INITIAL CONSULTATION', ar: 'الاستشارة الأولية' },
      description: {
        en: 'We begin by understanding your unique business needs, challenges, and strategic objectives',
        ar: 'نبدأ بفهم احتياجات عملك الفريدة وتحدياتك وأهدافك الاستراتيجية'
      },
      image: '/img/Jpegs for website-09.jpg'
    },
    {
      number: '2',
      title: { en: 'NEEDS ANALYSIS', ar: 'تحليل الاحتياجات' },
      description: {
        en: 'Comprehensive assessment of your requirements and market opportunities',
        ar: 'تقييم شامل لاحتياجاتك وفرص السوق المتاحة'
      },
      image: '/img/Jpegs for website-10.jpg'
    },
    {
      number: '3',
      title: { en: 'STRATEGIC PLANNING', ar: 'التخطيط الاستراتيجي' },
      description: {
        en: 'Developing customized solutions aligned with your vision and goals',
        ar: 'تطوير حلول مخصّصة تتوافق مع رؤيتك وأهدافك'
      },
      image: '/img/Jpegs for website-11.jpg'
    },
    {
      number: '4',
      title: { en: 'IMPLEMENTATION', ar: 'التنفيذ' },
      description: {
        en: 'Executing the plan with precision, quality, and attention to detail',
        ar: 'تنفيذ الخطة بدقة وجودة عالية مع الاهتمام بالتفاصيل'
      },
      image: '/img/Jpegs for website-12.jpg'
    },
    {
      number: '5',
      title: { en: 'QUALITY ASSURANCE', ar: 'ضمان الجودة' },
      description: {
        en: 'Rigorous testing and refinement to ensure optimal performance',
        ar: 'اختبارات دقيقة وتحسينات مستمرة لضمان أفضل أداء'
      },
      image: '/img/Jpegs for website-13.jpg'
    },
    {
      number: '6',
      title: { en: 'DELIVERY & SUPPORT', ar: 'التسليم والدعم' },
      description: {
        en: 'Successful project completion with ongoing support and maintenance',
        ar: 'إتمام المشروع بنجاح مع تقديم دعم وصيانة مستمرة'
      },
      image: '/img/Jpegs for website-14.jpg'
    }
  ];

  return (
    <section className="process-section" id="process">
      <h2 className="process-title">
        {language === 'ar' ? 'ألية' : 'OUR '}
        <span>{language === 'ar' ? 'العمل' : 'PROCESS'}</span>
      </h2>

      <p className="process-subtitle">
        {language === 'ar' 
          ? 'في الجبرية، نتبع منهجية واضحة تتمحور حول العميل لضمان نتائج مميزة وتنفيذ سلس للمشاريع عبر جميع قطاعات خدماتنا'
          : 'At Al-Jabriyah, we follow a structured and client-focused approach to ensure exceptional results and seamless project execution across all our service divisions.'
        }
      </p>

      <div className="process-container">
        {processes.map((process, index) => (
          <div key={index} className="process-box">
            <div className="circle">
              <div className="number">{process.number}</div>
              <img src={process.image} className="process-img" alt={process.title[language]} />
            </div>
            <h3>{process.title[language]}</h3>
            <p>{process.description[language]}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Process;